import React from 'react';
import DashboardLayout from '../components/dashboard/DashboardLayout';
import Dashboard from '../components/dashboard/Dashboard';

const DashboardPage = () => {
    return (
        <DashboardLayout>
            <Dashboard />
        </DashboardLayout>
    );
};

export default DashboardPage; 